<!-------------------------------- ข้อมูลหน้าหลัก --------------------------------->
<div *ngIf="selectBuilding == 0" class="fixed inset-0 z-[60] flex items-end justify-center bg-black/40 backdrop-blur-sm"
    (click)="close()">

    <div class="bg-white w-full rounded-t-3xl shadow-2xl  flex flex-col h-[80vh] relative"
        (click)="$event.stopPropagation()" [style.transform]="modalTransform" [style.transition]="modalTransition">

        <div class="bg-white sticky top-0 z-20 touch-none h-full">

            <div class="w-full flex justify-center pt-3 pb-1">
                <div class="w-12 h-1.5 bg-gray-300 rounded-full"></div>
            </div>

            <div class="px-6 pb-4 pt-2 flex items-start justify-between relative" (touchstart)="onTouchStart($event)"
                (touchmove)="onTouchMove($event)" (touchend)="onTouchEnd()">
                <div class="flex gap-4 items-center">
                    <div
                        class="flex-shrink-0 w-14 h-14 bg-gray-50 rounded-xl border border-gray-100 p-1 flex items-center justify-center overflow-hidden shadow-sm">
                        <img [src]="listBuilding.logo" alt="logo" class="w-full h-full object-contain">
                    </div>

                    <div class="flex flex-col">
                        <h2 class="text-xl font-bold text-gray-900 leading-tight">{{ name }}</h2>
                        <div class="flex items-center text-sm text-gray-500 mt-1 gap-2">
                            <span class="bg-blue-100 text-blue-700 px-2 py-0.5 rounded text-xs font-medium">
                                {{ distance.toFixed(2) }} km
                            </span>
                            <span class="text-gray-400">•</span>
                            <span>{{ listBuilding.timeIn }} - {{ listBuilding.timeOut }}</span>
                        </div>
                        <p class="text-xs text-gray-400 mt-0.5 truncate max-w-[200px]">
                            {{ listBuilding.address || (currentLanguage === "TH" ? 'ไม่ระบุที่อยู่' : 'No address')
                            }}
                        </p>
                    </div>
                </div>

                <button (click)="close()"
                    class="p-2 bg-gray-100 hover:bg-gray-200 rounded-full text-gray-500 transition-colors">
                    <svg class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>
            </div>

            <div class="flex-1 overflow-y-auto pb-24 scroll-smooth h-[calc(100vh-300px)] ">
                <div class="relative w-full h-48 bg-gray-100 mb-4">
                    <div *ngIf="heroImages.length" class="hero-rail w-full h-full flex overflow-x-auto snap-x snap-mandatory"
                        (scroll)="onHeroScroll($event)">
                        <button *ngFor="let url of heroImages; let i = index; trackBy: trackByUrl" type="button"
                            (click)="openHeroViewer(i)"
                            class="w-full h-full flex-shrink-0 snap-center border-0 p-0 bg-gray-100 cursor-zoom-in">
                            <img [src]="url" alt="" class="w-full h-full object-cover"
                                [attr.loading]="i === 0 ? 'eager' : 'lazy'">
                        </button>
                    </div>

                    <div *ngIf="!heroImages.length"
                        class="w-full h-full flex flex-col items-center justify-center text-gray-400">
                        <svg class="w-10 h-10 mb-2 opacity-50" fill="none" stroke="currentColor"
                            viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                                d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z">
                            </path>
                        </svg>
                        <span class="text-sm">No Image</span>
                    </div>

                    <span *ngIf="heroImages.length > 1"
                        class="absolute top-3 right-3 px-2 py-0.5 rounded-full bg-black/55 text-white text-[10px] font-bold tabular-nums pointer-events-none">
                        {{ heroIndex + 1 }}/{{ heroImages.length }}
                    </span>
                    <div *ngIf="heroImages.length > 1"
                        class="absolute bottom-3 left-0 right-0 flex justify-center gap-1.5 pointer-events-none">
                        <div *ngFor="let url of heroImages; let i = index; trackBy: trackByUrl"
                            class="h-1.5 rounded-full transition-all shadow-sm"
                            [ngClass]="heroIndex === i ? 'bg-amber-400 w-3' : 'bg-white/60 w-1.5'">
                        </div>
                    </div>
                </div>

                <div *ngIf="profile" class="px-5 mb-5 space-y-3">
                    <p *ngIf="profileSummary" class="text-sm text-gray-600 leading-relaxed line-clamp-3">
                        {{ profileSummary }}
                    </p>
                    <app-site-amenities *ngIf="profile.amenities.length" [amenities]="profile.amenities"
                        [lang]="currentLanguage" variant="chips" [max]="6"></app-site-amenities>
                    <button type="button" (click)="goToSiteDetail()"
                        class="w-full flex items-center justify-center gap-1.5 rounded-xl bg-slate-800 text-white text-sm font-bold py-2.5 active:scale-[0.98] transition-transform">
                        {{ currentLanguage === 'TH' ? 'ดูรายละเอียดลาน' : 'View parking details' }}
                        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M9 5l7 7-7 7" />
                        </svg>
                    </button>
                </div>

                <div class="px-5 mb-6">
                    <div class="grid grid-cols-2 gap-3">
                        <div
                            class="bg-yellow-200/80 border border-yellow-100 rounded-2xl p-3 flex flex-col justify-center items-center">
                            <span class="text-xs text-yellow-600 font-semibold mb-1 uppercase tracking-wider">
                                {{ currentLanguage === 'TH' ? 'ค่าบริการเริ่มต้น' : 'Start Price' }}
                            </span>
                            <div class="flex items-baseline gap-1">
                                <span class="text-2xl font-bold text-gray-600">
                                    {{ listBuilding.price_car || 0 }}
                                </span>
                                <span class="text-xs text-gray-500">฿/Hr</span>
                            </div>
                        </div>

                        <div
                            class="bg-green-200 border border-green-100 rounded-2xl p-3 flex flex-col justify-center items-center">
                            <span class="text-xs text-green-700 font-semibold mb-1 uppercase tracking-wider">
                                {{ currentLanguage === 'TH' ? 'ว่าง' : 'Available' }}
                            </span>
                            <div class="flex items-baseline gap-1">
                                <span class="text-2xl font-bold text-green-700">
                                    {{ allBuildingsParkingAvailable }}
                                </span>
                                <span class="text-xs text-gray-400">/ {{ allBuildingsParking }}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="px-5 mb-3 flex items-center justify-between border-t border-gray-100 pt-3">
                    <h3 class="text-lg font-bold text-gray-800 flex items-center gap-2">
                        <svg class="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M4 6h16M4 10h16M4 14h16M4 18h16" />
                        </svg>
                        {{ currentLanguage === "TH" ? "อาคารจอดรถ" : "Parking Zones" }}
                    </h3>
                    <button (click)="openModalRecommend()"
                        class="text-xs text-blue-600 font-medium flex items-center gap-1 bg-blue-50 px-2 py-1 rounded-lg">
                        <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                        {{ currentLanguage === "TH" ? "ข้อมูล" : "Info"}}
                    </button>
                </div>

                <div class="px-5 flex flex-col gap-3">
                    <div *ngFor="let item of listBuilding?.buildingInfo"
                        class="bg-white border border-gray-100 shadow-sm rounded-2xl p-4 flex items-center justify-between transition-shadow hover:shadow-md">

                        <div>
                            <div class="font-bold text-gray-800 text-base mb-1">{{ item.buildingName }}</div>

                            <div class="flex items-center gap-2 text-xs">
                                <span class="bg-gray-100 text-gray-600 px-2 py-0.5 rounded-md">
                                    {{ item.floors.length }} Floor
                                </span>

                                <div class="flex items-center gap-1 text-gray-500">
                                    <span class="w-1.5 h-1.5 rounded-full bg-green-500"></span>
                                    <span>
                                        {{ calculateBuildingAvailable(item.buildingId)}}
                                        {{ currentLanguage === "TH" ? '
                                        ช่องจอดว่าง' : ' parking available' }}
                                    </span>
                                </div>
                            </div>
                        </div>

                        <button (click)="filterBuilding(item.buildingId)" [disabled]="item.floors.length == 0"
                            class="bg-yellow-400 text-white px-4 py-2 rounded-xl text-sm font-medium shadow-md shadow-yellow-400/30 active:scale-95 transition-transform disabled:bg-gray-300 disabled:shadow-none">
                            {{ currentLanguage === "TH" ? "แสดง" : "Select" }}
                        </button>
                    </div>
                </div>
            </div>

            <div
                class="absolute bottom-0 w-full bg-white border-t border-gray-100 shadow-[0_-5px_20px_rgba(0,0,0,0.05)] pb-safe pt-2">
                <div class="flex justify-around items-center h-16">
                    <button (click)="selectNav(0)" [class.text-yellow-500]="activeIndex === 0"
                        class="flex flex-col items-center gap-1 text-gray-400 w-full">
                        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                        </svg>
                        <span class="text-[10px] font-medium">{{ currentLanguage === "TH" ? "สมัครสมาชิก" : "Register"
                            }}</span>
                    </button>

                    <button (click)="selectNav(1)" [class.text-yellow-500]="activeIndex === 1"
                        class="flex flex-col items-center gap-1 text-gray-400 w-full">
                        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                        </svg>
                        <span class="text-[10px] font-medium">{{ currentLanguage === "TH" ? "นำทาง" :
                            "Navigate" }}</span>
                    </button>

                </div>
            </div>

        </div>
    </div>
</div>


<!-------------------------------- ขยายรายละเอียด --------------------------------->
<div *ngIf="selectBuilding > 0"
    class="fixed inset-0 z-[60] bg-slate-50 flex flex-col h-[100dvh] w-full font-sans animation-fade-in">

    <div
        class="flex-none bg-white/80 backdrop-blur-md px-5 py-3 flex items-center justify-between sticky top-0 z-40 shadow-sm transition-all ">
        <div class="flex items-center gap-4">
            <button (click)="selectBuilding = 0"
                class="w-10 h-10 flex items-center justify-center rounded-full bg-white border border-gray-100 shadow-sm text-gray-600 hover:bg-gray-50 hover:scale-105 active:scale-95 transition-all">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M15 19l-7-7 7-7" />
                </svg>
            </button>
            <div>
                <h1 class="text-lg font-bold text-gray-800 leading-tight tracking-tight">
                    {{ filteredBuildingList.buildingName }}
                </h1>
                <div class="flex items-center gap-2 mt-0.5">
                    <span class="relative flex h-2 w-2">
                        <span
                            class="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
                        <span class="relative inline-flex rounded-full h-2 w-2 bg-green-500"></span>
                    </span>
                    <span class="text-xs font-medium text-gray-500">
                        {{ currentLanguage === "TH" ? "เปิดให้บริการ" : "Open Now" }}
                    </span>
                </div>
            </div>
        </div>

        <div class="flex flex-col items-end">
            <span class="text-xl font-extrabold text-yellow-700 leading-none">
                ฿{{ (listBuilding.price_car + listBuilding.price_motorcycle) || 0 }}
            </span>
            <span class="text-[10px] text-gray-400 font-medium">/ {{ currentLanguage === "TH" ? "ชม." : "hr" }}</span>
        </div>
    </div>

    <div class="flex-1 overflow-y-auto bg-slate-50 relative pb-10">

        <div class="relative w-full h-[220px] bg-gray-200">
            <div class="w-full h-full overflow-hidden relative shadow-sm z-10">
                <div class="flex transition-transform duration-500 ease-out h-full"
                    [style.transform]="'translateX(-' + currentImageIndex_floor * 100 + '%)'">
                    <ng-container *ngIf="imageFloorList && imageFloorList.length > 0; else noImage">
                        <div *ngFor="let img of imageFloorList" class="w-full h-full flex-shrink-0"
                            (click)="imageExpand_floors = true">
                            <img [src]="img" class="w-full h-full object-cover">
                        </div>
                    </ng-container>
                    <ng-template #noImage>
                        <div
                            class="w-full h-full flex flex-col gap-2 items-center justify-center bg-gray-100 text-gray-400">
                            <svg class="w-10 h-10 opacity-20" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z">
                                </path>
                            </svg>
                            <span class="text-xs font-medium opacity-50">No Image</span>
                        </div>
                    </ng-template>
                </div>

                <!-- Navigation buttons for floor list -->
                <div *ngIf="imageFloorList.length > 1"
                    class="absolute inset-0 flex items-center justify-between px-2 z-20 pointer-events-none">
                    <button (click)="previousImage_floor($event)"
                        class="bg-black/30 text-white p-1.5 rounded-full backdrop-blur-md hover:bg-black/50 pointer-events-auto shadow-lg transition-all active:scale-90">
                        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5"
                                d="M15 19l-7-7 7-7" />
                        </svg>
                    </button>
                    <button (click)="nextImage_floor($event)"
                        class="bg-black/30 text-white p-1.5 rounded-full backdrop-blur-md hover:bg-black/50 pointer-events-auto shadow-lg transition-all active:scale-90">
                        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M9 5l7 7-7 7" />
                        </svg>
                    </button>
                </div>

                <div
                    class="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-black/40 to-transparent pointer-events-none">
                </div>

                <div *ngIf="imageFloorList.length > 1"
                    class="absolute bottom-4 left-0 right-0 flex justify-center gap-2 z-20">
                    <div *ngFor="let img of imageFloorList; let i = index"
                        class="h-1.5 rounded-full transition-all duration-300 backdrop-blur-sm"
                        [ngClass]="currentImageIndex_floor === i ? 'w-6 bg-yellow-400 shadow-md' : 'w-1.5 bg-white/50'">
                    </div>
                </div>
            </div>
        </div>

        <!-- <div class="relative flex justify-center">
            <div class=" w-24 h-2 bg-yellow-700/50 rounded-b-xl relative"></div>
            <div class="absolute top-1 left-1/2 -translate-x-1/2 w-7 h-7 bg-gray-50 rounded-full z-10"></div>
        </div> -->
        <div class="px-5 mt-6 relative z-20 space-y-5">


            <div class="bg-white p-5 rounded-2xl shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-gray-100">
                <div class="flex items-center justify-between mb-4">
                    <h3 class="text-sm font-bold text-gray-400 uppercase tracking-wider">{{ currentLanguage === "TH" ?
                        "ข้อมูลช่องจอดรถ" : "Total Capacity"}}</h3>
                    <span class="text-2xl font-black text-yellow-800">
                        {{ (allBuildingCarParking || 0) + (allBuildingMotorcycleParking || 0) + (allBuildingEvParking ||
                        0) }}
                    </span>
                </div>

                <div class="grid grid-cols-3 gap-3">
                    <div
                        class="flex flex-col items-center justify-center p-3 rounded-xl bg-yellow-50/50 border border-yellow-100/50">
                        <svg class="w-5 h-5 text-yellow-500 mb-1" fill="currentColor" viewBox="0 0 24 24">
                            <path
                                d="M18.92 6.01C18.72 5.42 18.16 5 17.5 5h-11c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 11l1.5-4.5h11L19 11H5z" />
                        </svg>
                        <span class="text-xs text-gray-500 font-medium">Car</span>
                        <span class="text-lg font-bold text-yellow-600 leading-tight">{{ allBuildingCarParking }}</span>
                    </div>
                    <div
                        class="flex flex-col items-center justify-center p-3 rounded-xl bg-yellow-50/50 border border-yellow-100/50">
                        <img class="w-5 h-5 mb-1 opacity-80"
                            src="data:image/png;base64,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">
                        <span class="text-xs text-gray-500 font-medium">Moto</span>
                        <span class="text-lg font-bold text-yellow-600 leading-tight">{{ allBuildingMotorcycleParking
                            }}</span>
                    </div>
                    <div
                        class="flex flex-col items-center justify-center p-3 rounded-xl bg-yellow-50/50 border border-yellow-100/50">
                        <svg class="w-5 h-5 text-yellow-500 mb-1" fill="currentColor" viewBox="0 0 24 24">
                            <path d="M7 2v11h3v9l7-12h-4l4-8z" />
                        </svg>
                        <span class="text-xs text-gray-500 font-medium">EV</span>
                        <span class="text-lg font-bold text-yellow-600 leading-tight">{{ allBuildingEvParking }}</span>
                    </div>
                </div>
            </div>
            <div class="flex items-center justify-between gap-6">
                <div class="bg-yellow-700/50 w-full h-1 rounded-full">
                </div>
                <div class="bg-yellow-700/50 w-full h-1 rounded-full">
                </div>
            </div>
            <div class="flex items-center justify-between pt-3 border-t border-gray-200">
                <h3 class="font-bold text-gray-800 text-lg pl-1">
                    {{ currentLanguage === "TH" ? "ช่องจอดว่างรายชั้น" : "Floor Parking Available" }}
                </h3>
                <!-- <div class="flex items-center gap-2 px-3 py-1 bg-white border border-gray-100 rounded-full shadow-sm">
                    <span class="relative flex h-1.5 w-1.5">
                        <span
                            class="animate-ping absolute inline-flex h-full w-full rounded-full  opacity-75"></span>
                        <span class="relative inline-flex rounded-full h-1.5 w-1.5 bg-red-500"></span>
                    </span>
                    <span class="text-[10px] font-bold text-gray-500 uppercase tracking-wide">Live</span>
                </div> -->
            </div>

            <div
                class="bg-white rounded-2xl shadow-[0_2px_15px_rgb(0,0,0,0.03)] border border-gray-100 overflow-hidden">
                <ng-container *ngFor="let item of tableBuildingParking; let last = last">
                    <div class="p-4 flex items-center justify-between hover:bg-gray-50 transition-colors cursor-default group"
                        [class.border-b]="!last" [class.border-gray-50]="!last">

                        <div class="flex items-center gap-4">
                            <div
                                class=" max-w-[180px] py-1 px-2 h-11 rounded-full bg-slate-50 border border-slate-100 flex items-center justify-center group-hover:bg-yellow-100 group-hover:border-yellow-200 transition-colors">
                                <span class="truncate text-sm font-bold text-gray-700 group-hover:text-yellow-700">
                                    {{ item.floor }}
                                </span>
                            </div>
                        </div>

                        <div class="flex items-center gap-6">
                            <div class="text-center" [class.opacity-30]="item.carParking_available == 0">
                                <span class="block text-sm font-bold text-gray-800">{{ item.carParking_available
                                    }}</span>
                                <span class="block text-[10px] text-gray-400 font-medium uppercase">Car</span>
                            </div>
                            <div class="text-center" [class.opacity-30]="item.motorcycleParking_available == 0">
                                <span class="block text-sm font-bold text-gray-800">{{ item.motorcycleParking_available
                                    }}</span>
                                <span class="block text-[10px] text-gray-400 font-medium uppercase">Moto</span>
                            </div>
                            <div class="text-center relative" [class.opacity-30]="item.evParking_available == 0">
                                <span class="block text-sm font-bold text-green-600">{{ item.evParking_available
                                    }}</span>
                                <span class="block text-[10px] text-gray-400 font-medium uppercase">EV</span>
                            </div>
                        </div>

                    </div>
                </ng-container>

                <div *ngIf="!tableBuildingParking?.length" class="text-center py-12 text-gray-400">
                    <span class="block text-sm font-medium">No Data Available</span>
                </div>
            </div>

            <div class="h-10"></div>
        </div>
    </div>
</div>

<app-loader *ngIf="isLoading" [state]="selectBuilding"></app-loader>
<app-toast-warn *ngIf="isWarning" [language]="currentLanguage" [isButton]="false" [timeIn]="3000"
    (close)="isWarning = $event" [detail]="detailWarn"></app-toast-warn>
<app-toast-failed *ngIf="isError" [language]="currentLanguage" [timeIn]="3000" (close)="isError = $event"
    [detail]="detailError"></app-toast-failed>
<app-toast-success *ngIf="isSuccess" [language]="currentLanguage" (close)="isSuccess = $event" [timeIn]="3000"
    [detail]="detailSuccess"></app-toast-success>

<!-------------------------------- ขยายรูปภาพลาน (profile / อาคาร) --------------------------------->
<app-image-viewer *ngIf="isViewerOpen" [images]="heroImages" [startIndex]="viewerIndex" [lang]="currentLanguage"
    (closed)="isViewerOpen = false"></app-image-viewer>

<!-------------------------------- ขยายรายละเอียดรูปภาพ (ชั้น) --------------------------------->
<div *ngIf="imageExpand_floors"
    class="fixed inset-0 z-[100] bg-black/70 backdrop-blur-xl flex flex-col items-center justify-center p-4 animation-fade-in"
    (click)="imageExpand_floors = false">
    <button (click)="imageExpand_floors = false"
        class="absolute top-6 right-6 p-3 bg-white/10 hover:bg-white/20 rounded-full text-white transition-all z-[110]">
        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M6 18L18 6M6 6l12 12" />
        </svg>
    </button>

    <div class="relative w-full max-w-5xl max-h-[85vh] flex items-center justify-center"
        (click)="$event.stopPropagation()">
        <img *ngIf="imageFloorList" [src]="imageFloorList[currentImageIndex_floor]"
            class="max-w-full max-h-[85vh] object-contain rounded-lg shadow-2xl">

        <div *ngIf="imageFloorList.length > 1" class="absolute inset-x-0 flex items-center justify-between px-2">
            <button (click)="previousImage_floor($event)"
                class="bg-white/20 hover:bg-white/40 text-white p-4 rounded-full backdrop-blur-md transition-all">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M15 19l-7-7 7-7" />
                </svg>
            </button>
            <button (click)="nextImage_floor($event)"
                class="bg-white/20 hover:bg-white/40 text-white p-4 rounded-full backdrop-blur-md transition-all">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M9 5l7 7-7 7" />
                </svg>
            </button>
        </div>
    </div>

    <div *ngIf="imageFloorList.length > 1" class="mt-8 flex gap-2">
        <div *ngFor="let img of imageFloorList; let i = index" class="h-1.5 rounded-full transition-all duration-300"
            [ngClass]="currentImageIndex_floor === i ? 'w-8 bg-yellow-400' : 'w-2 bg-white/30'">
        </div>
    </div>
</div>